import React, {ReactNode} from 'react';
import clsx from 'clsx';
import {StyledCard} from './index.styled';

type AppCardProps = {
  className?: string;
  title?: string | ReactNode;
  action?: ReactNode | string;
  actions?: ReactNode | string[] | React.ReactNode[];
  extra?: ReactNode | string;
  cover?: any;
  footer?: any;
  children?: ReactNode;
  heightFull?: boolean;
  bordered?: boolean;
  noPadding?: boolean;

  [x: string]: any;
};

const AppCard: React.FC<AppCardProps> = ({
  title,
  extra,
  children,
  cover,
  className,
  actions,
  heightFull,
  bordered = false,
  noPadding = false,
  ...rest
}) => {
  return (
    <StyledCard
      className={clsx({heightFull, noPadding}, className)}
      title={title}
      extra={extra ? extra : null}
      cover={cover}
      actions={actions as React.ReactNode[]}
      bordered={bordered}
      {...rest}
    >
      {children}
    </StyledCard>
  );
};

export default AppCard;
